import React from 'react';

import classNames from 'classnames';

const PlayButton = (props) => {
  const playButtonStyles = classNames(
    'mt-control-item',
    'mt-play-button',
    'icon-huge',
    {
      'icon-pause': props.isPlaying,
      'icon-play': !props.isPlaying,
    },
    'text--blue-dark'
  );
  return (
    <div className={playButtonStyles} onClick={props.playHandler}></div>
  );
};

export default PlayButton;



/** WEBPACK FOOTER **
 ** ./core_components/TimingHandler/TimeNavigation/controls/PlayButton.js
 **/